import { createSlice } from "@reduxjs/toolkit";

import { initialState } from "./interface";

export const SupportTicketsSlice = createSlice({
  name: "supporttickets",
  initialState: initialState,
  reducers: {
    request: (state) => {
      state.isFetching = true;
      state.isError = false;
    },
    success: (state, action) => {
      state.isFetching = false;
      state.tickets = action.payload;
      state.isError = false;
    },
    error: (state, action) => {
      state.isFetching = false;
      state.isError = true;
    },
  },
});

export const { actions: SupportTicketsAction } = SupportTicketsSlice;

export default SupportTicketsSlice.reducer;
